import {useI18n} from '@logistics-frontend/core/i18n'
import {negate} from 'lodash'
import React, {useMemo} from 'react'

import {DetailsProps} from '../../types'
import {formatWhiteListItemsProp} from '../../utils'
import {DetailsList} from '../details-list'
import {getRequirements, hasMultiplier, mapRequirementsToListItems} from './utils'

const Requirements: React.FC<Omit<DetailsProps, 'zone'>> = ({tariff, currencySign}) => {
  const t = useI18n()
  const isCargo = tariff.category_name === 'cargo'
  const requirements = useMemo(() => {
    const requirements = getRequirements(tariff).filter(negate(hasMultiplier))
    const unit = isCargo ? `${currencySign}/${t('tariffs.units.time')}` : currencySign

    return formatWhiteListItemsProp(mapRequirementsToListItems(requirements, unit))
  }, [tariff, isCargo, currencySign, t])

  return (
    <DetailsList
      items={requirements}
      subtitle={
        isCargo
          ? t(
              'tariffs.block_subtitle.requirements',
              'С 1 по 60 минуту оплата производится за весь час, с 61 — оплата за каждую минуту',
            )
          : undefined
      }
      title={t('tariffs.block_title.requirements')}
    />
  )
}

export default Requirements
